// Generated by purs version 0.15.16
import * as API_SelStudent from "../API.SelStudent/index.js";
import * as Concur_Core_LiftWidget from "../Concur.Core.LiftWidget/index.js";
import * as Concur_Core_Types from "../Concur.Core.Types/index.js";
import * as Concur_React_DOM from "../Concur.React.DOM/index.js";
import * as Concur_React_Props from "../Concur.React.Props/index.js";
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Monoid from "../Data.Monoid/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Effect_Class from "../Effect.Class/index.js";
import * as Internal_Util from "../Internal.Util/index.js";
import * as React_SyntheticEvent from "../React.SyntheticEvent/index.js";
import * as Steps_Step3_FormView from "../Steps.Step3.FormView/index.js";
import * as Steps_Step3_State from "../Steps.Step3.State/index.js";
import * as Steps_Step3_Types from "../Steps.Step3.Types/index.js";
import * as Steps_WorkQueue_State from "../Steps.WorkQueue.State/index.js";
import * as Steps_WorkQueue_View from "../Steps.WorkQueue.View/index.js";
import * as Translate from "../Translate/index.js";
import * as Widgets_Dropdown from "../Widgets.Dropdown/index.js";
var bind = /* #__PURE__ */ Control_Bind.bind(Concur_Core_Types.bindWidget);
var discard = /* #__PURE__ */ Control_Bind.discard(Control_Bind.discardUnit)(Concur_Core_Types.bindWidget);
var liftEffect = /* #__PURE__ */ Effect_Class.liftEffect(/* #__PURE__ */ Concur_Core_Types.monadEffectWidget(Data_Monoid.monoidArray));
var pure = /* #__PURE__ */ Control_Applicative.pure(Concur_Core_Types.applicativeWidget);
var multiAlternativeWidget = /* #__PURE__ */ Concur_Core_Types.multiAlternativeWidget(Data_Monoid.monoidArray);
var div$prime = /* #__PURE__ */ Concur_React_DOM["div$prime"](multiAlternativeWidget)(Concur_Core_Types.shiftMapWidgetWidget);
var button = /* #__PURE__ */ Concur_React_DOM.button(multiAlternativeWidget)(Concur_Core_Types.shiftMapWidgetWidget);
var voidRight = /* #__PURE__ */ Data_Functor.voidRight(Concur_React_Props.functorProps);
var text = /* #__PURE__ */ Concur_React_DOM.text(Concur_Core_LiftWidget.liftWidgetWidget);
var map = /* #__PURE__ */ Data_Functor.map(Data_Functor.functorArray);
var map1 = /* #__PURE__ */ Data_Functor.map(Concur_Core_Types.functorWidget);
var a = /* #__PURE__ */ Concur_React_DOM.a(multiAlternativeWidget)(Concur_Core_Types.shiftMapWidgetWidget);
var header = /* #__PURE__ */ Concur_React_DOM.header(multiAlternativeWidget)(Concur_Core_Types.shiftMapWidgetWidget);
var div = /* #__PURE__ */ Concur_React_DOM.div(multiAlternativeWidget)(Concur_Core_Types.shiftMapWidgetWidget);
var h1 = /* #__PURE__ */ Concur_React_DOM.h1(multiAlternativeWidget)(Concur_Core_Types.shiftMapWidgetWidget);
var h2 = /* #__PURE__ */ Concur_React_DOM.h2(multiAlternativeWidget)(Concur_Core_Types.shiftMapWidgetWidget);
var append1 = /* #__PURE__ */ Data_Semigroup.append(Data_Semigroup.semigroupArray);
var renderWorkQueue = function (preservedQuery) {
    return function (state) {
        return bind(Steps_WorkQueue_View.workQueueWidgetWithRoute(preservedQuery)(state.editor.workQueueState)(state.editor.workQueueUi)(state.editor.workQueueCache))(function (result) {
            if (result instanceof Steps_WorkQueue_View.JumpToForm) {
                return discard(liftEffect(React_SyntheticEvent.preventDefault(result.value1)))(function () {
                    return pure(new Steps_Step3_Types.WorkQF(result));
                });
            };
            return pure(new Steps_Step3_Types.WorkQF(result));
        });
    };
};
var renderExportDropdown = function (v) {
    return function (v1) {
        if (v1.editor.fillState.doc.exports.length === 0) {
            return div$prime([  ]);
        };
        if (v1.editor.fillState.doc.exports.length === 1) {
            return button([ voidRight(new Steps_Step3_Types.ExportF(v1["editor"]["fillState"]["doc"]["exports"][0]))(Concur_React_Props.onClick), Concur_React_Props.className("btn btn-export"), Concur_React_Props.disabled(v) ])([ text(Translate.lookupTranslation("export")) ]);
        };
        var mkItem = function ($$export) {
            return {
                label: $$export.label,
                value: $$export
            };
        };
        var items = map(mkItem)(v1.editor.fillState.doc.exports);
        var button1 = button([ Concur_React_Props.onClick, Concur_React_Props.disabled(v || !Steps_WorkQueue_State["formForSelected$prime"](v1.editor.workQueueState)), Concur_React_Props.className("btn btn-export") ])([ text(Translate.lookupTranslation("export")) ]);
        return map1(Steps_Step3_Types.ExportF.create)(Widgets_Dropdown.dropdownButton(button1)(items));
    };
};
var renderHeader = function (busy) {
    return function (state) {
        var lockToggleLabel = function (v) {
            return function (v1) {
                if (v && v1 instanceof Data_Maybe.Nothing) {
                    return Translate.lookupTranslation("save-and-lock");
                };
                if (v1 instanceof Data_Maybe.Nothing) {
                    return Translate.lookupTranslation("lock");
                };
                if (v1 instanceof Data_Maybe.Just) {
                    return Translate.lookupTranslation("unlock");
                };
                throw new Error("Failed pattern match at Steps.Step3.View (line 149, column 5 - line 149, column 62): " + [ v.constructor.name, v1.constructor.name ]);
            };
        };
        var lockToggleActionClass = function (v) {
            if (v instanceof Data_Maybe.Nothing) {
                return "lock-document-action";
            };
            if (v instanceof Data_Maybe.Just) {
                return "unlock-document-action";
            };
            throw new Error("Failed pattern match at Steps.Step3.View (line 154, column 5 - line 154, column 57): " + [ v.constructor.name ]);
        };
        var lockToggleItem = (function () {
            if (state.editor.fillState.doc.can.lock) {
                return [ a([ (function () {
                    if (busy) {
                        return Concur_React_Props.className("dropdown-item disabled whitespace-nowrap");
                    };
                    return voidRight(Steps_Step3_Types.ToggleLockF.value)(Concur_React_Props.onClick);
                })(), Concur_React_Props.className("dropdown-item whitespace-nowrap " + (lockToggleActionClass(state.editor.fillState.doc.locked_at) + (function () {
                    if (busy) {
                        return " disabled";
                    };
                    return "";
                })())) ])([ text(lockToggleLabel(Steps_Step3_State.shouldSaveCurrentDocument(state))(state.editor.fillState.doc.locked_at)) ]) ];
            };
            return [  ];
        })();
        var dropBtn = button([ Concur_React_Props.className("dropdown-button"), Concur_React_Props.onClick ])([ text("\u2807") ]);
        var disableSave = busy || (!Steps_Step3_Types.hasEditableFields(state.editor.fillState) || !Steps_WorkQueue_State["formForSelected$prime"](state.editor.workQueueState));
        var disableNext = (function () {
            var $56 = Steps_Step3_Types.onLastItem(state.editor);
            if ($56) {
                return busy || !Steps_WorkQueue_State["formForSelected$prime"](state.editor.workQueueState);
            };
            return !Steps_WorkQueue_State["formForSelected$prime"](state.editor.workQueueState);
        })();
        var autofillItem = (function () {
            if (busy) {
                return [ a([ Concur_React_Props.className("dropdown-item disabled whitespace-nowrap autofill-form-action") ])([ text(Translate.lookupTranslation("autofill-form-button")) ]) ];
            };
            var $58 = Data_Maybe.isNothing(state.editor.fillState.doc.locked_at);
            if ($58) {
                return [ a([ voidRight(Steps_Step3_Types.AutofillF.value)(Concur_React_Props.onClick), Concur_React_Props.className("dropdown-item whitespace-nowrap autofill-form-action") ])([ text(Translate.lookupTranslation("autofill-form-button")) ]) ];
            };
            return [ a([ Concur_React_Props.className("dropdown-item disabled whitespace-nowrap autofill-form-action"), Concur_React_Props.title(Translate.lookupTranslation("autofill-disabled-reason-lock")) ])([ text(Translate.lookupTranslation("autofill-form-button")) ]) ];
        })();
        return header([ Concur_React_Props.className("page-header") ])([ div([ Concur_React_Props.className("page-headings") ])([ h1([ Concur_React_Props.className("page-heading") ])([ text(API_SelStudent.studentName(state.editor.workQueueCache.account)(state.editor.fillState.doc.student)) ]), h2([ Concur_React_Props.className("page-subheading") ])([ text(state.editor.fillState.form.label) ]) ]), div([ Concur_React_Props.className("btn-group") ])(Data_Array.catMaybes([ new Data_Maybe.Just(button([ voidRight(Steps_Step3_Types.CancelF.value)(Concur_React_Props.onClick), Concur_React_Props.className("btn btn-cancel"), Concur_React_Props.disabled(busy) ])([ text(Translate.lookupTranslation("cancel")) ])), new Data_Maybe.Just(renderExportDropdown(busy)(state)), new Data_Maybe.Just(button([ voidRight(Steps_Step3_Types.SaveF.value)(Concur_React_Props.onClick), Concur_React_Props.className("btn btn-save btn-primary"), Concur_React_Props.disabled(disableSave) ])([ text(Translate.lookupTranslation("save")) ])), Internal_Util.justIf(!Steps_Step3_Types.onFirstItem(state.editor))(button([ voidRight(Steps_Step3_Types.PrevF.value)(Concur_React_Props.onClick), Concur_React_Props.className("btn btn-previous") ])([ text(Translate.lookupTranslation("prev")) ])), new Data_Maybe.Just(button([ voidRight(Steps_Step3_Types.NextF.value)(Concur_React_Props.onClick), Concur_React_Props.className("btn btn-next btn-primary"), Concur_React_Props.disabled(disableNext) ])([ text((function () {
            var $59 = Steps_Step3_Types.onLastItem(state.editor);
            if ($59) {
                return Translate.lookupTranslation("finish");
            };
            return Translate.lookupTranslation("next");
        })()) ])), new Data_Maybe.Just(Widgets_Dropdown.dropdownButton_(dropBtn)(append1(autofillItem)(lockToggleItem))) ])) ]);
    };
};
var renderEditorPane = function (renderOptions) {
    return function (busy) {
        return function (state) {
            return Steps_Step3_FormView.renderFormFill(renderOptions.signatures)(busy)(state.editor);
        };
    };
};
var renderStep3 = function (renderOptions) {
    return function (preservedQuery) {
        return function (state) {
            var busy = Steps_Step3_State.isBusy(state);
            return div([ Concur_React_Props.className("step-3-scroll overflow-y-auto") ])([ div([ Concur_React_Props.className("step-container step-3"), Concur_React_Props.key("step-3-container"), Concur_React_Props["_id"]("step-3-container") ])(Data_Array.catMaybes([ Internal_Util.justIf(renderOptions.sideAndTopBar)(renderHeader(busy)(state)), Internal_Util.justIf(renderOptions.sideAndTopBar)(renderWorkQueue(preservedQuery)(state)), new Data_Maybe.Just(renderEditorPane(renderOptions)(busy)(state)) ])) ]);
        };
    };
};
export {
    renderStep3
};
//# sourceMappingURL=index.js.map
